import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';
import { RechardUSDTInput } from '../models/transferRecord.model';

@Injectable()
export class RechargeService {

  constructor(
    private httpService: HttpService) { }

  //获取所有充值方式
  //TQQ 2017-01-04
  getBanks() {
    let url = AppConfig.GetProdUrl() + "/Index/Banks";
    return this.httpService.get(url);
  }

  //充值
  //TQQ 2017-01-04
  recharge(toUserName: string, amount: number, bankId: number) {
    let param = "toUserName=" + toUserName + "&amount=" + amount + "&bankId=" + bankId;
    let url = AppConfig.GetProdUrl() + "/Funds/Recharge";
    return this.httpService.get(url + "?" + param);
  }

  //支付宝人工（高速充值）
  //TQQ 2017-01-04
  zfbrgRecharge(param) {
    let url = AppConfig.GetProdUrl() + "/Funds/RechardZfbrg";
    return this.httpService.get(url + '?' + param);
  }
  zfbrgRecharge1(amount: number, addtime?, bankid?, realname?) {
    let param = "amount=" + amount + "&addtime=" + addtime + "&bankid=" + bankid + "&realname=" + realname;
    let url = AppConfig.GetProdUrl() + "/Funds/RechardZfbrg";
    return this.httpService.get(url + "?" + param);
  }
  //支付宝自动
  //TQQ 2017-01-04
  zfbzdRecharge(amount: number, username: string, bankid: string) {
    let param = "amount=" + amount + "&aliUserName=" + username + "&bankid=" + bankid;
    let url = AppConfig.GetProdUrl() + "/Funds/RechardZfbzd";
    return this.httpService.get(url + "?" + param);
  }

  //支付
  //TQQ 2017-08-29
  rechargePost(params) {
    let url = AppConfig.GetProdUrl() + "/Funds/RechargeApiTest";
    return this.httpService.post(url, params);
  }
  updateCommt(parms) {
    let url = AppConfig.GetProdUrl() + "/Funds/UpdateCommtReCharge";
    return this.httpService.get(url, parms);
  }

  /**
   * 获取第三方网银列表
   * TQQ 2018-12-27
   */
  getThirdWyList(bankCode) {
    let url = AppConfig.GetProdUrl() + "/Index/GetThirdWyList";
    return this.httpService.post(url, { bankCode: bankCode });
  }
  //银行卡线下充值新界面下一步
  getOrder(params) {
    // let param = "amount=" + amount + "&bankcode=" +bankcode+"&realname="+realname;
    // let url = AppConfig.GetProdUrl() + "/Funds/AddOfflineRechard";
    let url = AppConfig.GetProdUrl() + "/Funds/AddOfflineRechard";
    return this.httpService.post(url, params);
  }
  //银行卡线下充值新界面提交订单
  pushOrder(params) {
    // let param = "amount=" + amount + "&addtime=" +bankcode+"&realname="+realname+"&recordcode="+recordcode;
    let url = AppConfig.GetProdUrl() + "/Funds/SureOfflineRechard";
    return this.httpService.post(url, params);
  }

  /**
     * 获取Usdt设置
     */
  getUsdtSetting() {
    let url = AppConfig.GetProdUrl() + "/Funds/GetUSDTSetting";
    return this.httpService.get(url);
  }
  /**
   * 添加Usdt转账
   */
  addUsdtRechard(input: RechardUSDTInput) {
    let url = AppConfig.GetProdUrl() + "/Funds/AddRechardUSDT";
    return this.httpService.post(url, input);
  }
  /**
 * 
 * 代客充值获取充值暗号
 */
  getPayTheSecretCode() {
    let url = AppConfig.GetProdUrl() + '/Chat/GetPayTheSecretCode';
    return this.httpService.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/services/recharge.service.ts